import React, { useCallback, useContext, useMemo } from 'react'
import { childrenSelectWarning, maxFlightInfantAge, maxFlightChildAge, maxFlightPassengerCount, maxInfantsWarning } from 'constants/flight'
import { validateFlightOccupants } from 'lib/flights/flightUtils'

import OccupancyItem from 'components/Common/OccupancyPicker/OccupancyItem'
import MessageBanner from 'components/Luxkit/Banners/MessageBanner'
import FlightSearchWidgetDispatchContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetDispatchContext'
import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import { FlightSearchWidgetActions } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'

function FlightSearchTravellerSelectContent() {
  const state = useContext(FlightSearchWidgetStateContext)
  const dispatch = useContext(FlightSearchWidgetDispatchContext)

  const { occupants } = state

  const onChangeOccupants = useCallback((itemId: number, nextOccupancy: App.Occupants) => {
    dispatch({ type: FlightSearchWidgetActions.SET_OCCUPANTS, occupants: nextOccupancy })
  }, [dispatch])

  const hasInfants = occupants.childrenAge?.some((age) => age !== -1 && age <= maxFlightInfantAge)

  const capacity = useMemo(() => ([{
    adults: maxFlightPassengerCount - (occupants.childrenAge?.length ?? 0),
    children: maxFlightPassengerCount - occupants.adults,
    infants: maxFlightPassengerCount - occupants.adults,
  }]), [occupants])

  const invalidSelection = useMemo(() => validateFlightOccupants(occupants), [occupants])

  return (<div>
    <OccupancyItem
      itemId={0}
      occupancy={occupants}
      onChange={onChangeOccupants}
      maxChildAge={maxFlightChildAge}
      maxInfantAge={maxFlightInfantAge}
      childrenAgeLabel="at time of return flight"
      capacities={capacity}
      smallView
    />
    {hasInfants && !invalidSelection && <MessageBanner
      kind="warning"
      description={childrenSelectWarning}
    />}
    {invalidSelection && <MessageBanner
      kind="warning"
      description={maxInfantsWarning}
    />}
  </div>
  )
}

export default FlightSearchTravellerSelectContent
